<template>
  <b-nav
    v-if="isOneDriveEnabled"
    class="mb-4"
    :class="{ [customClass]: !!customClass }"
    pills
    small
  >
    <b-nav-item :active="isActive('documents.list')" :to="documentsTo">
      <Icon icon="hdd" size="14" class="mr-2" />
      {{ __('documents.system') }}
    </b-nav-item>
    <b-nav-item
      :active="isActive('driveDocuments.list')"
      :to="driveDocumentsTo"
    >
      <Icon icon="cloud" size="14" class="mr-2" />
      {{ __('documents.one-drive') }}
    </b-nav-item>
  </b-nav>
</template>

<script>
import { IS_ONE_DRIVE_ENABLED_GETTER } from '@/Modules/Base/SettingModule.js'
import { mapGetters } from 'vuex'

export default {
  name: 'DocumentResourceNav',

  props: {
    customClass: {
      type: String,
      default: 'my-3',
    },
  },

  computed: {
    ...mapGetters('SettingModule', {
      isOneDriveEnabled: IS_ONE_DRIVE_ENABLED_GETTER,
    }),
    documentsTo() {
      return {
        name: `${this.$route.name.replace('driveDocuments', 'documents')}`,
        params: this.$route.params,
      }
    },
    driveDocumentsTo() {
      return {
        name: `${this.$route.name
          .replace('documents', 'driveDocuments')
          .replace('.folder', '')}`,
        params: this.$route.params,
      }
    },
  },

  methods: {
    isActive(to) {
      if (typeof to === 'string') {
        return this.$route?.name.includes(to)
      }
    },
  },
}
</script>